export default function ($http) {
    return function (vehicleId, keeperId) {
        return $http.delete(`api/vehicles/${ vehicleId }/keepers/${ keeperId }`)
                    .then(x => {
                        const correct = x.data.result;
                        if (!correct) {
                            throw new Error(`Could not delete keeper ${ keeperId }`);
                        }
                    });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/keeperDelete.js